<template onLoad="onLoad()">
  <div class="purse-body">
    <div class="Content-subject">
      <!-- 公司地址  地图 -->
      <div class="map">
        <div class="map-box">
          <!-- 地址 /文字：左地址，右联系方式 -->
          <div class="map-Text">
            <div class="map-Text-left">
              <div
                class="map-Text-left-item"
                v-for="(item, index) in obj.address"
                :key="index"
              >
                <p class="orientation-icon"></p>
                <span
                  class="firm-clickable"
                  :style="
                    address == item ? 'color: #409eff ;' : ' color: #333333;'
                  "
                  @click="handelClickItem(item)"
                  >{{ item }}</span
                >
              </div>
            </div>
            <div class="map-Text-right">
              <p class="telephone-icon"></p>
              <p>{{ phone }}</p>
              <p class="TheLetter-icon"></p>
              <p>{{ mail }}</p>
            </div>
          </div>
          <!-- 地址 /地图 -->
          <div class="map-map" ref="mapContainer" id="dynamic-map"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getSysAboutPageUsByCode, // 根据code获取关于我们下对应页面信息
} from "../../../assets/api/JobInterview";
export default {
  data() {
    return {
      address: "",
      mail: "",
      phone: "",
      obj: {},
      map: null,
      scriptLoaded: false,
      scriptTag: null,
      zoomLevel: 12, // 跟踪当前缩放级别
      resizeTimer: null, // 用于防抖处理
      tk: "60e23f3b260d465f5d309db17674ee47",
      apiVersion: "4.0",
      Coordinates: 116.40769,
      Coordinates1: 39.90403,
      addressMapArr: [],
    };
  },
  components: {},
  //
  created() {
    this.getSysAboutPageUsByCode();
  },
  mounted() {
    // 初始化地图
    this.loadTiandituScript();
  },
  beforeUnmount() {
    this.cleanupEnvironment();
    this.removeScriptTag();
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {
    // // 监听
    Coordinates: {
      handler(newSs, old) {
        // 使用$nextTick确保DOM已完全渲染
        this.$nextTick(() => {
          this.loadTiandituScript();
          // 监听窗口大小变化，确保地图尺寸正确
          window.addEventListener("resize", this.handleResize);
        });
      },
      immediate: false,
    },
  },
  methods: {
    loadTiandituScript(forceReload = false) {
      if (forceReload) {
        this.cleanupEnvironment();
      }

      if (!this.scriptLoaded && !window.T) {
        this.loadScript();
        return;
      }

      if (forceReload) {
        this.loadScript();
        return;
      }

      this.initMap();
    },

    loadScript() {
      const timestamp = new Date().getTime();
      // 使用协议相对路径，自动适配HTTP/HTTPS
      const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
      const src = `${protocol}//api.tianditu.gov.cn/api?v=4.0&tk=${this.tk}&_t=${timestamp}`;

      this.removeScriptTag();

      this.scriptTag = document.createElement("script");
      this.scriptTag.src = src;
      this.scriptTag.type = "text/javascript";
      this.scriptTag.async = true;

      this.scriptTag.onload = () => {
        this.scriptLoaded = true;
        this.initMap();
      };

      this.scriptTag.onerror = () => {
        console.error("天地图API加载失败");
        this.scriptLoaded = false;
      };

      document.head.appendChild(this.scriptTag);
    },

    initMap() {
      this.clearMapContainer();

      if (!this.$refs.mapContainer || !window.T) {
        console.error("初始化失败：容器或API不存在");
        return;
      }

      try {
        // 1. 创建地图实例
        this.map = new T.Map(this.$refs.mapContainer);
        this.map.centerAndZoom(
          new T.LngLat(this.Coordinates, this.Coordinates1),
          this.zoomLevel
        );

        // 2. 关键修复：先禁用再启用滚轮缩放，强制重置状态
        this.map.disableScrollWheelZoom();
        this.map.enableScrollWheelZoom(true);

        // 3. 强制地图重新计算容器尺寸（核心修复点）
        this.map.checkResize();

        // 4. 监听缩放事件，同步缩放级别并验证事件有效性
        this.map.addEventListener("zoomend", this.handleZoomEnd);

        // 5. 主动触发一次微小缩放，激活缩放状态
        setTimeout(() => {
          this.map.setZoom(this.zoomLevel + 0.1);
          setTimeout(() => this.map.setZoom(this.zoomLevel), 100);
        }, 500);
      } catch (error) {
        console.error("地图实例创建失败:", error);
      }
    },

    // 处理缩放结束事件，验证缩放是否生效
    handleZoomEnd() {
      this.zoomLevel = this.map.getZoom();
      console.log("缩放级别更新:", this.zoomLevel);
    },

    // 处理窗口大小变化，确保地图尺寸正确
    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        if (this.map) {
          this.map.checkResize();
        }
      }, 100);
    },

    cleanupEnvironment() {
      if (this.map) {
        // 移除缩放事件监听
        this.map.removeEventListener("zoomend", this.handleZoomEnd);

        // 销毁实例前先禁用缩放，避免状态残留
        this.map.disableScrollWheelZoom();

        if (typeof this.map.destroy === "function") {
          this.map.destroy();
        }
        this.map = null;
      }

      if (window.T) {
        delete window.T;
      }

      this.scriptLoaded = false;
      this.clearMapContainer();
    },

    clearMapContainer() {
      if (this.$refs.mapContainer) {
        this.$refs.mapContainer.innerHTML = "";
        // 确保容器尺寸正确（避免0尺寸导致缩放无效）
        this.$refs.mapContainer.style.width = "100%";
        this.$refs.mapContainer.style.height = "400px";
      }
    },

    removeScriptTag() {
      if (this.scriptTag && this.scriptTag.parentNode) {
        this.scriptTag.parentNode.removeChild(this.scriptTag);
        this.scriptTag = null;
      }
    },

    reloadMap() {
      this.loadTiandituScript(true);
    },
    // 点击切换地址
    handelClickItem(item) {
      for (var i in this.addressMapArr) {
        if (this.addressMapArr[i].key == item) {
          var coordinate = this.addressMapArr[i].val;
          var parts = coordinate.split(",");
          console.log(parts);
          this.Coordinates = parts[0];
          this.Coordinates1 = parts[1];
          console.log(this.Coordinates, this.Coordinates1, "1111111");

          this.reloadMap();
        }
      }
      this.address = item;
    },
    // -----------------------根据code获取关于我们下对应页面信息-------------
    async getSysAboutPageUsByCode() {
      var data = {
        data: {
          code: "ZJY002",
        },
      };
      const res = await getSysAboutPageUsByCode(data);
      console.log(JSON.parse(res.data.extra));
      this.obj = JSON.parse(res.data.extra);

      this.phone = this.obj.phone;
      this.mail = this.obj.mail;
      this.address = this.obj.address[0];

      this.addressMapArr = Object.entries(this.obj.addressMap).map(
        ([key, val]) => ({
          key,
          val,
        })
      );

      for (var i in this.addressMapArr) {
        if (this.addressMapArr[i].key == this.address) {
          var coordinate = this.addressMapArr[i].val;
          var parts = coordinate.split(",");
          console.log(parts);
          this.Coordinates = parts[0];
          this.Coordinates1 = parts[1];
          console.log(this.Coordinates, this.Coordinates1, "1111111");
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
// 最外层div
.purse-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // 内容主体
  .Content-subject {
    width: 100%;
    flex: 1;
    min-height: 540px;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 5px;
    padding:30px ;
    box-sizing: border-box;
    // 公司地址
    .map {
      width: 100%;
      min-height: 310px;
      display: flex;
      flex-direction: column;
      background: #ffffff;
      box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
      border-radius: 10px;
      .map-box {
        height: 100%;
        margin: 20px;
        // 地址/文字
        .map-Text {
          width: 100%;
          min-height: 22px;
          line-height: 22px;
          display: flex;
          align-items: flex-start;
          margin-bottom: 10px;
          .map-Text-left {
            flex: 1;
            min-width: 0;
            display: flex;
            flex-direction: column;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            font-weight: 400;
            .map-Text-left-item {
              display: flex;
              align-items: center;
              margin-bottom: 10px;
              text-indent: 0;
              &:last-child {
                margin-bottom: 0;
              }
              span {
                cursor: pointer;
                margin-left: 15px;
              }
            }
            .orientation-icon {
              width: 20px;
              height: 22px;
              flex-shrink: 0;
              background-image: url("../../../assets/imgs/dingwei@3x.svg");
              background-size: 100% 100%;
            }
          }
          .map-Text-right {
            width: 400px;
            flex-shrink: 0;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            p {
              font-family: PingFangSC-Medium;
              font-size: 12px;
              color: #333333;
              font-weight: 400;
            }
            .telephone-icon {
              width: 20px;
              height: 19px;
              background-image: url("../../../assets/imgs/dianhua-weijiaohuan@3x.svg");
              background-size: 100% 100%;
              margin-right: 5px;
            }
            .TheLetter-icon {
              width: 20px;
              height: 15px;
              background-image: url("../../../assets/imgs/youxiang@3x.svg");
              background-size: 100% 100%;
              margin-left: 30px;
              margin-right: 5px;
            }
          }
        }
        // 地址/地图
        .map-map {
          width: 100%;
          height: 225px;
          background-image: url("../../../assets/imgs/map.svg");
          background-size: 100% 100%;
          margin-top: 20px;
          box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
        }
      }
    }
  }
}
</style>
